import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { Item } from "../../types/item";

async function fetchPIPHome(itemNo: string): Promise<Item> {
  return await httpClient.tasks.get<Item>(`/items/pip-home?itemNo=${itemNo}`);
}

export function usePIPHome(itemNo: string) {
  return useQuery({
    queryKey: ["PIP", "home", itemNo],
    queryFn: async () => await fetchPIPHome(itemNo),
    staleTime: INTERVAL.DAY,
    refetchOnWindowFocus: false,
    enabled: !!itemNo,
  });
}
